import { common, baseComponents } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

function loginByQQ(loginManager) {
  if (Vue.prototype.$miloLoginManager) {
    loginManager.mobileLoginByQQConnect({
      appId: '101813972',
      redirectUri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
      sUrl: location.href,
    });
  } else {
    loginManager.login({
      iUseQQConnect: window.iUseQQConnect, // 是否使用QQ互联
      oQQConnectParams: {
        appId: '101813972',
        redirect_uri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
      },
    });
  }
  localStorage.curPlatform = 'qq';
}
function loginByWx(loginManager) {
  if (Vue.prototype.$miloLoginManager) {
    const option = {
      appId: 'wxfb66a4e99e630765',
      scope: 'snsapi_userinfo',
      sUrl: location.href,
      userinfoSpan: 'userinfo',
      forcePopup: true,
      snapShotTips: true,
      snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的领取、发货等操作”',
    };
    loginManager.mobileLoginByWX(option);
  } else {
    const option = {
      appConfig: {
        avoidConflict: '', // 这里建议为空字符串，这样只会在微信客户端中做防串号
        QQBrowserAppId: '106', // 在QQ浏览器端申请的APPID，保持不变
        WxAppId: 'wxfb66a4e99e630765', // 需要在微信申请openLink权限，
        AppName: '超核玩家公众号', // 业务的中文名称
        scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
        LogoUrl: 'http://ossweb-img.qq.com/images/feiji/web201507/logo.png', // 业务在授权时需要显示的正方形标准Logo，
      },
      userinfoSpan: 'userinfo',
      forcePopup: true,
      snapShotTips: true,
      snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的领取、发货等操作”',
    };

    console.log('loginByWx option=', option);
    console.log('loginByWx option=', option);

    loginManager.loginByWX(option);
  }
  localStorage.curPlatform = 'wx';
}

export default class LoginBase {
  async initLogin() {
    window.ams_login_avoid_conflict = true;
    console.log('LoginBase initLogin begin');
    return await new Promise((resolve) => {
      console.log('supercore initLogin begin');
      console.log('Vue.prototype.$actInfo.layout_type', Vue.prototype.$actInfo.layout_type);
      if (Vue.prototype.$actInfo.layout_type === 'c-supercore-page-qqroom') {
        // 当页面为QQ大厅使用QQ-PT登录
        window.iUseQQConnect = 0;
      } else {
        // 其他情况使用QQ-互联登录
        window.iUseQQConnect = 1;
      }
      // window.iUseQQConnect = common.tool.getCookie('acctype') === 'qc' ? 1 : 0;
      if (Vue.prototype.$miloLoginManager) {
        loginManagerInstance = new Vue.prototype.$miloLoginManager({
          commonParams: {
            iUseQQConnect: window.iUseQQConnect,
            useAppLogin: ['tgclub'],
          },
          mobileParams: {
            oWXParams: {
              gameDomain: 'supercore.qq.com',
              appId: 'wxfb66a4e99e630765',
              scope: 'snsapi_userinfo',
              sUrl: location.href,
            },
            oQQConnectParams: {
              appId: '101813972',
              redirectUri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
              sUrl: location.href,
            },
          },
        });
        console.log('supercore initLogin done instance=', loginManagerInstance);
        resolve();
      } else {
        // todo 以上稳定后删除此逻辑
        // 过渡期兼容旧的cdn版本

        window.milo.ready(() => {
          window.need('biz.login', (LoginManager) => {
            LoginManager.init({
              appConfig: {
                avoidConflict: '', // 这里建议为空字符串，这样只会在微信客户端中做防串号
                gameDomain: 'supercore.qq.com',
                WxAppId: 'wxfb66a4e99e630765',
                scope: 'snsapi_userinfo',
              },
              oQQConnectParams: {
                appId: '101813972',
                redirect_uri: 'https://supercore.qq.com/comm-htdocs/login/qc_redirect.html',
              },
              iUseQQConnect: window.iUseQQConnect,
            });
            loginManagerInstance = LoginManager;
            console.log('supercore initLogin done instance=', loginManagerInstance);
            resolve();
          });
        });
      }
    });
  }

  async login(params = { loginType: 'qq' }) {
    console.log('LoginBase login|params=', params);
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  }
  async checkLogin(params) {
    console.log('LoginBase checkLogin|params=', params);
    return await new Promise((resolve) => {
      console.log('loginManagerInstance', loginManagerInstance);

      if (location.href.indexOf('FLUSH_COOKIE=') > 0) {
        clearAllCookie();
        let newHref = location.href;
        newHref = common.tool.setUrlParam('FLUSH_COOKIE', '', newHref);
        location.href = newHref;
      }
      const appid = common.tool.getQueryparams('appid');
      const openid = common.tool.getQueryparams('openid');
      const acctype = common.tool.getQueryparams('acctype');
      const accessToken = common.tool.getQueryparams('access_token');

      if (appid && openid && acctype && accessToken) {
        // 写cookie
        // const cookies = `appid=;openid=3086137608;acctype=qq;access_token=@ZrbIlXNOI`;
        let changeAcctype = acctype;
        if (acctype === 'qq' && accessToken.length > 10) changeAcctype = 'qc';
        if (acctype === 'weixin') changeAcctype = 'wx';
        const cookies = `appid=${appid};openid=${openid};acctype=${changeAcctype};access_token=${accessToken}`;
        console.log('default url pass cookie=', cookies);
        common.tool.setCookies(cookies);
        resolve({
          isLogin: true,
          userInfo: {
            nickName: common.tool.getQueryparams('nickname') || '当前用户',
          },
        });
        return;
      };

      if (Vue.prototype.$miloLoginManager) {
        loginManagerInstance.checkRealLogin().then((res) => {
          const { isLogin, userInfo, result } = res;
          console.log('checkRealLogin', userInfo);
          // 同步一份loginType到userInfo,兼容旧组件逻辑
          userInfo.loginType = result.loginType;
          // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
          let { curPlatform } = localStorage;
          console.log('checkRealLogin curPlatform from localStorage ', curPlatform);

          if (!curPlatform) {
            curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
          }
          console.log('checkRealLogin curPlatform ', curPlatform);
          resolve({
            isLogin,
            userInfo,
          });
        })
          .catch((err) => {
            console.error('checkRealLogin Failed Code:', err.errCode);
            console.error('checkRealLogin Failed info:', err.errInfo);
            clearAllCookie();
            resolve({
              isLogin: false,
              userInfo: {},
            });
          });
      } else {
        // todo 以上稳定后删除此逻辑
        // 过渡期兼容旧的cdn版本
        loginManagerInstance.checkRealLogin((userInfo) => {
          console.log('checkRealLogin', userInfo);
          // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
          let { curPlatform } = localStorage;
          console.log('checkRealLogin curPlatform from localStorage ', curPlatform);

          if (!curPlatform) {
            curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
          }
          console.log('checkRealLogin curPlatform ', curPlatform);

          if (window.milo.cookie.get('acctype') === 'qc') {
            // qc 登录,获取qq信息
            let uin = common.tool.getCookie('uin') || '';
            uin = uin.substr(1);
            if (uin.indexOf('0') === 0) {
              uin = uin.substr(1);
            }
            // QQ号不显示 昵称 因为有会有表情文字其是乱码
            // eslint-disable-next-line no-param-reassign
            userInfo.nickName = uin || userInfo.nickname;
            loginManagerInstance.getUserFace((sAvatar) => {
              console.log(' get QQ getUserFace sAvatar ', sAvatar);
              // eslint-disable-next-line no-param-reassign
              userInfo.avatar = typeof sAvatar === 'string' ? sAvatar : sAvatar.userFace;
              console.log(' get QQ Userinfo ', userInfo);
              if (userInfo) {
                resolve({
                  isLogin: true,
                  userInfo,
                });
              } else {
                resolve({
                  isLogin: false,
                  userInfo: {},
                });
                clearAllCookie();
              }
            });
          } else {
            // wx 登录,获取微信信息
            const getUserInfoParam = {
              openid: common.tool.getCookie('openid'),
              access_token: common.tool.getCookie('access_token'),
              lang: 'zh_CN',
            };
            console.log('getUserInfoByWxOpenId=', getUserInfoParam);

            loginManagerInstance.getUserInfoByWxOpenId(getUserInfoParam, (wxUserInfo) => {
              console.log('登录成功，wx用户信息为', wxUserInfo);
              // eslint-disable-next-line no-param-reassign
              userInfo.avatar = wxUserInfo.headimgurl ? `${wxUserInfo.headimgurl}/64` : '';
              // eslint-disable-next-line no-param-reassign
              userInfo.nickName = wxUserInfo.nickname;
              resolve({
                isLogin: true,
                userInfo,
              });
            }, (err) => {
              console.log('获取用户信息失败', err);
              clearAllCookie();
              resolve({
                isLogin: false,
                userInfo: {},
              });
            });
          }
        }, (error) => {
          console.error('checkRealLogin Failed:', error);
          clearAllCookie();
          resolve({
            isLogin: false,
            userInfo: {},
          });
        });
      }
    });
  }
  async logout(params) {
    console.log('LoginBase logout|params=', params);
    if (Vue.prototype.$miloLoginManager) {
      await loginManagerInstance.logout().then((res) => {
        // ios存在登出链接地址异常问题
        clearAllCookie();
        console.log('supercore user logout res:', res);
        sessionStorage.setItem('logouted', 'true');
        const url = window.location.href.split('?')[0];
        window.location.href = url;
      });
    } else {
      // todo 以上稳定后删除此逻辑
      // 过渡期兼容旧的cdn版本
      await loginManagerInstance.logout({
        logoutCallback: () => {
          // ios存在登出链接地址异常问题
          clearAllCookie();
          sessionStorage.setItem('logouted', 'true');
          const url = window.location.href.split('?')[0];
          window.location.href = url;
        },
      });
    }
  }
  async checkRoleInfo(params) {
    console.log('LoginBase checkRoleInfo|params=', params);
    return await new Promise(async (resolve) => {
      console.log('Vue.prototype.$actInfo.game_code', Vue.prototype.$actInfo);
      const localStorageCeiba = JSON.parse(window.localStorage.getItem(`ceiba-${Vue.prototype.$actInfo.activity_id}-${Vue.prototype.$actInfo.game_code}`)) || {
        gameCode: null,
        sArea: null,
        sPartition: null,
        sRoleId: null,
      };
      console.log('ceiba-localStroage ==', localStorageCeiba);

      const { gameCode, sArea, sPartition, sRoleId } = localStorageCeiba;
      console.log('sPartition=', sPartition, 'sRoleId=', sRoleId, 'sArea=', sArea, 'gameCode=', gameCode);
      try {
        if (sRoleId) {
          const roleList = await baseComponents.Apis.Role.fetch({
            game_code: gameCode,
            partition_id: sPartition,
            device: common.platform.device,
          });
          console.log('fetch roleList = ', roleList);
          const roleInfo = roleList.find((e) => {
            if (e.role_id === sRoleId) return true;
            if (e.game_open_id === e.role_id) return true;
            if (e.game_open_id === decodeURI(e.role_id)) return true;
            return false;
          });
          if (roleInfo) {
            resolve({
              defaultPlugin: false,
              isRoleReady: true,
              roleInfo,
            });
          }
          console.log('fetch current roleInfo nil', roleInfo);
        } else {
          console.log('fetch current roleInfo vacancy');
          resolve({
            defaultPlugin: true,
            isRoleReady: false,
            roleInfo: {},
          });
        }
      } catch (e) {
        console.log('fetch roleList fail, e=', e);
        resolve({
          defaultPlugin: true,
          isRoleReady: false,
          roleInfo: {},
        });
      }
    });
  }
}

function clearAllCookie(level = 0) {
  const ptCookies = ['skey', 'uin'];
  const keys = document.cookie?.match(/[^ =;]+(?==)/g)?.filter((key) => {
    if (common.platform.isQQ) {
      // qq客户端内,不删除skey和uin这两个cookie
      return !ptCookies.includes(key);
    }
    return true;
  }) || [];
  if (keys.length === 0) return;
  const keysFormat = Array.from(new Set(keys));
  const host = location.hostname.split('.');
  const domainList = [];
  for (let i = 0; i < host.length - 1; i++) {
    if (level > i) {
      // 判断需要跳过的子域名层级,默认0为当前子域名
      continue;
    }
    domainList.push(host.slice(i - host.length).join('.'));
  }
  keysFormat.forEach((key) => {
    domainList.forEach((domain) => {
      if (level === 0) {
        // 真全删,domain不设
        clearCookie(key, '');
      } else {
        // 只尝试删除当前父域
        clearCookie(key, domain);
      }
    });
  });
}

/**
 * @description 清除cookie
 * @param {String} key key
 * @param {String} domain cookie域
 * @returns
 */
function clearCookie(key, domain = location.hostname, path = '/') {
  let cookieStr = `${key}=;expires=${new Date(0).toUTCString()}`;
  if (domain !== '') {
    cookieStr += `;domain=${domain}`;
  }
  if (path !== '') {
    cookieStr += `;path=${path}`;
  }
  document.cookie = cookieStr;
}
